import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { BlogImageGalleryCard as Original } from 'components/molecules'
import {
  BlogImageGalleryCardSettings,
  BlogImageGalleryCardFloatingSettings,
} from './BlogImageGalleryCardSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import {
  imageDefaultProps,
  imageItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const defaultProps = {
  ...imageDefaultProps(),
}

export const blogImageGalleryCardItemParams = (enabled, id, blockProps, children) => ({
  ...imageItemParams(blockProps),
  pk: id,
})

export const dynamicProps = []

export const BlogImageGalleryCard: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-blog-image-gallery-card ${props.className}`}
      >
        <Original
          item={blogImageGalleryCardItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

BlogImageGalleryCard.craft = withCraft({
  name: 'BlogImageGalleryCard',
  defaultProps: defaultProps,
  settings: BlogImageGalleryCardSettings,
  floatingSettings: BlogImageGalleryCardFloatingSettings,
})
